import { render } from "./PdfPresentation.vue?vue&type=template&id=681950f1&scoped=true"
import script from "./PdfPresentation.vue?vue&type=script&lang=js"
export * from "./PdfPresentation.vue?vue&type=script&lang=js"

import "./PdfPresentation.vue?vue&type=style&index=0&id=681950f1&scoped=true&lang=css"
import "./PdfPresentation.vue?vue&type=style&index=1&id=681950f1&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-681950f1"]])

export default __exports__